import React from 'react';
import LibrettoClip from '../LibrettoClip/LibrettoClip';

interface LibrettoShapeClipProps {
    librettoClipId: string;
    layerId: string;
}

const LibrettoShapeClip: React.FC<LibrettoShapeClipProps> = ({ librettoClipId, layerId }) => {
    return (
        <LibrettoClip librettoClipId={librettoClipId} layerId={layerId} filename="Shape" backgroundColor={"250, 238, 77"}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
            </svg>
        </LibrettoClip>
    );
};

export default LibrettoShapeClip;
